/**
 * Application Configuration
 * 
 * Centralized configuration and constants used throughout the application.
 */

/**
 * Supported languages
 */
export const LANGUAGES = ['fr', 'en'] as const;
export type Language = typeof LANGUAGES[number];

/**
 * Default language
 */
export const DEFAULT_LANGUAGE: Language = (import.meta.env.VITE_DEFAULT_LANGUAGE as Language) || 'en';

/**
 * Default story ID (fallback when no story is specified)
 */
export const DEFAULT_STORY_ID = import.meta.env.VITE_DEFAULT_STORY_ID || 'keepers-of-the-forgotten-magic';

/**
 * Application metadata
 */
export const APP_METADATA = {
  AUTHOR: import.meta.env.VITE_APP_AUTHOR || 'Chloé Nowak',
  TITLE: import.meta.env.VITE_APP_TITLE || 'Chloe Stories',
  VERSION: typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : '1.0.0',
} as const;

/**
 * Storage keys for localStorage
 */
export const STORAGE_KEYS = {
  MANIFEST: 'podcast_manifest',
  PLAYBACK_PREFIX: 'playback_',
  MANIFEST_VERSION: 'manifest_version',
  STORY_MANIFEST_PREFIX: 'story_manifest_',
} as const;

/**
 * API/Asset paths
 */
export const PATHS = {
  STORIES: '/stories',
  IMAGES: '/images',
  PROFILE: '/images/profile',
  BANNER: '/images/banner',
} as const;

/**
 * Playback settings
 */
export const PLAYBACK = {
  SPEEDS: [0.5, 0.75, 1.0, 1.25, 1.5, 1.75, 2.0],
  DEFAULT_SPEED: 1.0,
  DEFAULT_VOLUME: 1.0,
  SKIP_SECONDS: 10,
  SEEK_SECONDS: 5,
  POSITION_SAVE_INTERVAL: 5000, // 5 seconds
} as const;

/**
 * Debug mode
 */
export const DEBUG = import.meta.env.VITE_ENABLE_DEBUG === 'true';
